<template>
  <div>
    <h1 class="title">Login</h1>
    <form @submit.prevent="login">
      <b-message type="is-danger" v-if="authError" :closable="false">
        {{ authError }}
      </b-message>
      <b-message
        type="is-warning"
        v-else-if="reason == 'sessionExpired'"
        :closable="false"
      >
        Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.
      </b-message>
      <div class="field">
        <div class="control">
          <input
            class="input"
            v-model="username"
            type="text"
            placeholder="Login"
            :disabled="loading"
          />
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input
            class="input"
            v-model="password"
            type="password"
            placeholder="Passwort"
            :disabled="loading"
          />
        </div>
      </div>
      <div class="field">
        <div class="control">
          <button
            class="button is-primary"
            type="submit"
            v-bind:class="{ 'is-loading': loading }"
            :disabled="loading"
          >
            <b-icon icon="login"></b-icon>
            <span>
              Anmelden
            </span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auth from "../auth";

export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      authError: "",
      reason: this.$route.query.reason
    };
  },
  methods: {
    login() {
      this.loading = true;
      auth.login(this.username, this.password, (loggedIn, authError) => {
        if (!loggedIn) {
          this.authError = authError;
        } else {
          this.$router.replace(this.$route.query.redirect || "/");
        }
        this.loading = false;
      });
    }
  },
  created() {
    auth.logout();
  }
};
</script>
